export type ElioTheme = 'blue' | 'orange' | 'neutral' | 'success' | 'danger' | 'none';
